import { ServersApi } from 'src/orchd-client';

import { axiosInstance } from 'src/utils/axios';

export const serversApi = ServersApi({}, '/api', axiosInstance);
